import script from "./PortoFolio.vue?vue&type=script&setup=true&lang=js"
export * from "./PortoFolio.vue?vue&type=script&setup=true&lang=js"

import "./PortoFolio.vue?vue&type=style&index=0&id=effa1fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-effa1fda"]])

export default __exports__